import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class IncidentTrackerService {
  constructor(private readonly http: HttpClient) {}

  getIncidentTrackerList(offSet?: any, end?: any) {
    const params = `end=${end}&offset=${offSet}`;
    return this.http.get(`grc/incident?${params}`);
  }

  getProgram() {
    return this.http.get(`org/programs/`);
  }

  getProject() {
    return this.http.get(`projects/`);
  }

  getVendor() {
    return this.http.get(`vendors/names/`);
  }

  getDomain() {
    return this.http.get(`grc/incidentdomain/`);
  }

  getSubDomain() {
    return this.http.get(`grc/incidentsubdomain/`);
  }

  getUser() {
    return this.http.get(`users/user-list/`);
  }

  addNewIncidentTracker(data: any) {
    return this.http.post("grc/incident/", data);
  }

  updateIncidentTracker(id: any, data: any) {
    return this.http.put(`grc/incident/${id}/`, data);
  }

  deleteIncidentTracker(incidentId: any) {
    return this.http.delete(`grc/incident/${incidentId}/`);
  }

  getOwner() {
    return this.http.get(`users/user-list/`);
  }

  getIncidentType() {
    return this.http.get("base_value/?type=grc_incident_type");
  }

  getAuditResponseChoices() {
    return this.http.get("base_value/?type=audit_template_response");
  }

  downloadTemplate() {
    return this.http.get(`grc/audit-templates/default/`, {
      responseType: "blob",
    });
  }

  getAuditTemplates() {
    return this.http.get(`grc/audit-templates/`);
  }

  deletedAuditTemplate(id: any) {
    return this.http.delete(`grc/audit-templates/${id}`);
  }

  uploadFile(payload: any) {
    return this.http.post(`grc/audit-templates/`, payload);
  }

  createManualTemplate(payload: any) {
    return this.http.post(`grc/audit-templates/create-template/`, payload);
  }

  getAuditTemplateCategory() {
    return this.http.get("base_value/?type=grc_audit_category");
  }

  getFrequencies() {
    return this.http.get("base_value/?type=grc_frequency_type");
  }

  getAuditTypes() {
    return this.http.get("base_value/?type=grc_audit_type");
  }

  getFilteredAuditTemplates(qParam: string) {
    return this.http.get(`grc/audit-templates/?${qParam}`);
  }

  createAuditInstance(payload: any) {
    return this.http.post("grc/audit-instances/", payload);
  }

  getAuditInstances() {
    return this.http.get("grc/audit-instances/");
  }

  getAuditInstancesByProjectId(projectId: any) {
    return this.http.get(`grc/audit-instances/?project=${projectId}`);
  }

  getRecommendedAuditTemplatesByProjectId(projectId: any) {
    return this.http.get(
      `grc/audit-templates/recommended-templates/?project=${projectId}`
    );
  }

  getInstanceInfo(instanceId: any) {
    return this.http.get(`grc/audit-instances/${instanceId}/`);
  }

  getSeverityReport(instanceId: any) {
    return this.http.get(
      `grc/audit-instances/severity-report?id=${instanceId}`
    );
  }

  downloadResponseTemplate(templateId: any) {
    return this.http.get(
      `grc/audit-templates/${templateId}/response-template`,
      { responseType: "blob" }
    );
  }

  getIncidentStatus() {
    return this.http.get("base_value/?type=grc_incident_status");
  }

  getIncidentSeverity() {
    return this.http.get("base_value/?type=grc_incident_severity");
  }

  editInstanceResponse(responseId: any, payload: any) {
    return this.http.patch(`grc/audit-responses/${responseId}/`, payload);
  }

  uploadEvidence(responseId: any, payload: any) {
    return this.http.post(
      `grc/audit-responses/${responseId}/evidences/upload/`,
      payload
    );
  }

  downloadEvidence(instanceId: any) {
    return this.http.get(
      `grc/audit-responses/${instanceId}/evidences/download/`,
      {
        responseType: "blob",
      }
    );
  }

  deleteEvidence(responseId: number): Observable<any> {
    return this.http.delete(
      `grc/audit-responses/${responseId}/evidences/delete/`
    );
  }

  getFilteredAuditInstances(qParam: string) {
    return this.http.get(`grc/audit-instances/?${qParam}`);
  }

  getRiskAuditInstances(qParam: string) {
    return this.http.get(`grc/audit-instances/risk-audits/?${qParam}`);
  }

  getComplianceClauseAuditInstances() {
    return this.http.get(`grc/audit-instances/compliance-audits/`);
  }

  getFilteredIncidents(qParam: string) {
    return this.http.get(`grc/incident/?${qParam}`);
  }

  getAuditInsights() {
    return this.http.get("grc/audit-instances/insights/");
  }

  createAuditResponses(instanceId: any, payload: any) {
    return this.http.post(
      `grc/audit-instances/${instanceId}/responses/`,
      payload
    );
  }

  uploadAuditResponses(instanceId: any, formData: FormData) {
    return this.http.post(
      `grc/audit-instances/${instanceId}/upload-responses/`,
      formData
    );
  }

  getAuditQuestions(instanceId: any) {
    return this.http.get(`grc/audit-instances/${instanceId}/questions/`);
  }

  markAuditInstanceToProgress(instanceId: any) {
    return this.http.post(
      `grc/audit-instances/${instanceId}/mark-in-progress/`,
      {}
    );
  }

  deleteAuditResponseDocument(responseId: any, documentId: any) {
    return this.http.delete(
      `grc/audit-responses/${responseId}/documents/${documentId}/delete/`
    );
  }

  downloadAuditResponseDocument(responseId: any, documentId: any) {
    return this.http.get(
      `grc/audit-responses/${responseId}/documents/${documentId}/download/`,
      { responseType: "blob" }
    );
  }
}
